import { createAction } from 'redux-actions';
import { reduxKey } from './constants';
export const initializeHead = createAction(`${reduxKey}.INIT_HEAD`, (head)=>({
        head
    }));
